import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN, USER_INFO, INDEX_MAIN_PAGE_PATH } from '@/store/mutation-types'
import { generateIndexRouter, actionPath } from '@/utils/util'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/user/login', '/user/register', '/user/register-result', '/user/alteration'] // no redirect whitelist
function setToken() {
  const urlToken = localStorage.getItem('token')
  const tempUrlToken = localStorage.getItem('tempToken')
  const userInfo = localStorage.getItem('userInfo')
  if (urlToken) {
    localStorage.setItem('token', urlToken)
    Vue.ls.set(ACCESS_TOKEN, tempUrlToken, 7 * 24 * 60 * 60 * 1000)
    Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
  }
}
router.beforeEach((to, from, next) => {
  NProgress.start()
  setToken()
  // if (Vue.ls.get(ACCESS_TOKEN)) {
  if (localStorage.getItem('token')) {
    if (to.path === '/user/login') {
      next({ path: INDEX_MAIN_PAGE_PATH })
      NProgress.done()
    } else {
      // console.log('from---->>',from.path);
      // console.log('to---->>',to.path);
      actionPath(to)
      if (store.getters.permissionList.length === 0) {
        store
          .dispatch('GetPermissionList')
          .then((res) => {
            const menuData = res.result.menu
            if (menuData === null || menuData === '' || menuData === undefined) {
              return
            }
            let constRoutes = []
            constRoutes = generateIndexRouter(menuData)
            // 添加主界面路由
            store.dispatch('UpdateAppRouter', { constRoutes }).then(() => {
              router.addRoutes(store.getters.addRouters)
              const redirect = decodeURIComponent(from.query.redirect || to.path)
              if (to.path === redirect) {
                next({ ...to, replace: true })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            })
          })
          .catch((e) => {
            // console.log(e)
            // notification.error({
            //   message: '系统提示',
            //   description: '请求用户信息失败，请重试！'
            // })
            // store.dispatch('Logout').then(() => {
            //   next({ path: '/user/login', query: { redirect: to.fullPath } })
            // })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
